module.exports = __webpack_public_path__ + "img/full1-min.fb54bcaf.png";